import {
    CREATE_DISCOUNT,
    CREATE_DISCOUNT_FAILURE,
    CREATE_DISCOUNT_SUCCESS,
} from 'store/actions/types';

export const createDiscount = (payload) => {
    return {
        type: CREATE_DISCOUNT,
        payload: payload,
    };
};

export const createDiscountFailure = (error) => {
    return {
        type: CREATE_DISCOUNT_FAILURE,
        error: error,
    };
};

export const createDiscountSuccess = (response) => {
    return {
        type: CREATE_DISCOUNT_SUCCESS,
        id: response.id,
        response: response,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/discounts/createDiscounts.js